import { render, staticRenderFns } from "./view-files-list.vue?vue&type=template&id=4380e5fc&scoped=true"
import script from "./view-files-list.vue?vue&type=script&lang=js"
export * from "./view-files-list.vue?vue&type=script&lang=js"
import style0 from "./view-files-list.vue?vue&type=style&index=0&id=4380e5fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4380e5fc",
  null
  
)

export default component.exports